function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  clipRule: "evenodd",
  cx: 8,
  cy: 24,
  fillRule: "evenodd",
  r: 4.5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  clipRule: "evenodd",
  cx: 24,
  cy: 24,
  fillRule: "evenodd",
  r: 4.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  clipRule: "evenodd",
  cx: 40,
  cy: 24,
  fillRule: "evenodd",
  r: 4.5
});

var SvgCircles = function SvgCircles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "More options",
    className: "_8-yf5 ",
    fill: "#262626",
    height: 16,
    viewBox: "0 0 48 48",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circles.3dd3d052.svg";
export { ForwardRef as ReactComponent };